import { render, staticRenderFns } from "./ManterComarcaExibir.vue?vue&type=template&id=4e6aff3e&scoped=true&"
import script from "./ManterComarcaExibir.vue?vue&type=script&lang=js&"
export * from "./ManterComarcaExibir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6aff3e",
  null
  
)

export default component.exports